import { createI18n } from 'vue-i18n'
import en from './en'
import pt from './pt'

let userLocale = window.navigator.language
if (userLocale === 'pt-BR') {
  userLocale = 'pt'
}

export const i18n = createI18n({
  // Legacy API mode is deprecated in vue-i18n 11 and removed in 12. The app
  // only uses $t, which globalInjection still provides in Composition mode.
  legacy: false,
  globalInjection: true,
  locale: userLocale,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: {
    en,
    pt
  }
})
